<div class="header-container">
  @if (!isEditing) {
    <h2 class="title clickable" (click)="startEditing()">{{ projectorContainerName$ | async }}</h2>
  } @else {
    <mat-form-field class="name-input" appearance="outline">
      <input
        type="textarea"
        matInput
        [formControl]="nameFormControl"
        (blur)="finishEditing()"
        (keydown)="onKeyDown($event)"
        #nameInput
      />
    </mat-form-field>
  }

  <div>
    <ng-content></ng-content>
  </div>
</div>
